import { 
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  Input
} from '@angular/core';
import { ProductoService } from 'src/app/services/producto.service';
import { FollowService } from 'src/app/services/follow.service';
import { RestauranteService } from 'src/app/services/restaurante.service';
import { GLOBAL } from '../../../services/global';
import { Router } from '@angular/router';
import { MetricaService } from 'src/app/services/metrica.service';
import { ModalConfirmComponent } from '../../general/modal-confirm/modal-confirm.component';

declare const google: any;

@Component({
  selector: 'app-pagina-producto',
  templateUrl: './pagina-producto.component.html',
  styleUrls: ['./pagina-producto.component.css']
})
export class PaginaProductoComponent implements OnInit {

  arrayBotones = [];
  urlResources = GLOBAL.urlResourcesCarta;
  urlIcons = GLOBAL.urlIcons;
  url = "";
  closeResult: string;
  tagsMarca = [];
  tagsNormal = [];
  alergenos = [];
  newTagNormal: string;
  hashtagProducto: string;
  hashtagProductoSin: string;
  listTagNormal = [];
  tempMarca: any[];
  tempNormal: any[];
  follows: string;
  idProducto: number;
  slugProducto: any;
  slugFabricante: any;
  resultInsertFollow: any;
  urlTags: boolean = false;
  esInformacion: boolean = true;
  follow: boolean = false;
  urlContactoWhatsapp: string = "";
  pantallaCarga: boolean = false;
  cantidadCarrito: number = 1;
  precioDefecto: any = {};
  precioSeleccionado: any;
  refModalMensaje: any;
  diasSemana = [
    'lunes',
    'martes',
    'miercoles',
    "jueves",
    "viernes",
    "sabado",
    "domingo"
  ];
  diaSemanaHoy: any = 0;

  //Para el mapa
  map: any;
  isMobile: any;
  restaurantsArray: any = [];
  markers: Array<any> = [];
  pos: any = null;
  iconMyLocation: string = "/assets/img/my_location.png";

  @Input() producto: any;
  @Input() fabricante: any;

  @ViewChild("btnLike", null) btnLike: { nativeElement: any; }
  @ViewChild('modalMensaje', { read: ViewContainerRef, static: false }) entry: ViewContainerRef;

  constructor(
    private pService: ProductoService,
    private fService: FollowService,
    private resService: RestauranteService,
    private router: Router,
    private mService: MetricaService,
    private resolver: ComponentFactoryResolver
  ) {
  }

  ngOnInit() {
    this.url = GLOBAL.url;
    this.esInformacion = true;

    let currentUrl = window.location.href;
    if (currentUrl.indexOf("tags") != -1) {
      this.esInformacion = false;
      this.urlTags = true;
      // this.arrayBotones = GLOBAL.arrayBotonesQR(this.idProducto);
      // this.irMapaProducto(this.idProducto);
      this.arrayBotones = GLOBAL.arrayBotonesQR(this.slugProducto);
      this.irMapaProducto(this.slugProducto);
    }

    const hoy = new Date();
    this.diaSemanaHoy = hoy.getDay() - 1;

    if (this.diaSemanaHoy < 0) {
      this.diaSemanaHoy = 6;
    }

    this.getFormatearDatosProducto();

  }

  convertirSaltosDeLinea(texto) {
    if(texto != null) {
      return texto.replace(/\r\n|\r|\n/g, '<br>');
    } else {
      return "";
    }
  }

  // OBTENER LISTADO DE PLATOS DESDE LARAVEL
  getFormatearDatosProducto() {

    for (let precio of this.producto.precios) {
      if (precio.defecto == 1) {
        this.precioDefecto = precio;
        this.precioSeleccionado = precio;
      }
    }

    this.idProducto = this.producto.id;
    this.producto.id_fabricante = JSON.parse(this.producto.id_fabricante);
    this.slugFabricante = this.fabricante.slug;
    this.tempMarca = this.producto.hashtag;
    this.producto.alergenos = JSON.parse(this.producto.alergenos);
    this.hashtagProductoSin = this.producto.hashtag.replace('#', '');

    this.arrayBotones = GLOBAL.arrayBotonesFabri(this.slugFabricante);

  }

  getFraseHorarioEnvio(){

    let diaSemana = new Date().getDay();

    for(let mensaje of this.fabricante.mensajes_entrega) {
      if(mensaje.dia_semana == diaSemana) {
        if(mensaje.tipo == this.fabricante.responsable_envio_municipio) {
          if(this.esAntesDeHoraLimite()) {
            return mensaje.mensaje_antes_limite;
          }else{
            return mensaje.mensaje_despues_limite;
          }
        }
      }
    }
  }

  esAntesDeHoraLimite(): boolean {
    
    let horaLimite=null;

    if (this.fabricante.hora_limite_recogida == null) {
      return false; 
    }else if (this.fabricante.responsable_envio_municipio == "propio") {
      horaLimite = this.fabricante.hora_limite_recogida_propio;
    }else{
      horaLimite = this.fabricante.hora_limite_recogida;
    }
  
    const ahora = new Date();
    
    // Parsear la hora límite (formato "HH:mm")
    const [horaLimiteStr, minutoLimiteStr] = horaLimite.split(':');
    const horaLimiteNum = parseInt(horaLimiteStr, 10);
    const minutoLimiteNum = parseInt(minutoLimiteStr || '0', 10);
    
    // Crear fecha de referencia con la hora límite del día de hoy
    const horaReferencia = new Date();
    horaReferencia.setHours(horaLimiteNum, minutoLimiteNum, 0, 0);
    
    // Comparar timestamps
    return ahora.getTime() <= horaReferencia.getTime();
  }

  addMetrica(tipo_interaccion) {

    let modeloMetrica = {
      producto_id: this.idProducto,
      fabricante_id: this.fabricante.id,
      tipo_interaccion: tipo_interaccion
    }

    this.mService.addMetrica(modeloMetrica).subscribe(result => {
      if (result.result == "ok") {
        console.log("Metrica guardada");
      } else {
        console.log("Error a la hora de guardar en metrica");
      }
    });

  }

  irMapaProducto($id) {
    //Nos traemos todos los restaurantes que tengan como hashtag de marca este producto
    // this.pService.getInfoProducto($id).subscribe(result => {
    this.pService.getInfoProductoBySlug($id).subscribe(result => {
      this.hashtagProducto = result.hashtag;
      this.chargeMap();
      this.resService.getAllRestaurantsProductoMapa(this.hashtagProducto).subscribe(result => {
        this.restaurantsArray = result;
        this.runPrintMap();
      });
    });
  }

  chargeMap = () => {

    this.map = new google.maps.Map(document.getElementById('map'), {
      zoom: 18,
      streetViewControl: true,
      clickableIcons: false
    });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        this.map = new google.maps.Map(document.getElementById('map'), {
          center: this.pos,
          zoom: 6,
          streetViewControl: true,
          clickableIcons: false
        });

        new google.maps.Marker({
          position: this.pos,
          map: this.map,
          icon: {
            url: this.iconMyLocation,
            size: new google.maps.Size(20, 20),
            scaledSize: new google.maps.Size(20, 20),
            labelOrigin: new google.maps.Point(20, -20)
          },
        });

      });
    } else {
      alert("Browser doesn't support Geolocation");
    }
  }

  runPrintMap = () => {
    for (let i = 0; i < (<any>this.restaurantsArray).length; i++) {
      let restaurant = this.restaurantsArray[i];
      this.markers[restaurant.id] = new google.maps.Marker({
        position: { lat: parseFloat(restaurant.lat), lng: parseFloat(restaurant.lng) },
        map: this.map
      });

      this.markers[restaurant.id].addListener("click", () => {
        this.selectedDevice(restaurant);
        this.infoWindow(restaurant, this.markers[restaurant.id]);
      });
    }

    if (this.pos == null) {
      this.seeAllMarker();
    }


  }

  seeAllMarker() {
    let bounds = new google.maps.LatLngBounds();

    for (let i = 0; i < this.restaurantsArray.length; i++) {
      if (this.markers[this.restaurantsArray[i].id] != undefined) {
        bounds.extend(this.markers[this.restaurantsArray[i].id].getPosition());
      }
    }

    this.map.fitBounds(bounds);
  }

  selectedDevice(device: any) {
    if (this.markers[device.id] != undefined) {
      var pos = {
        lat: parseFloat(device.lat),
        lng: parseFloat(device.lng)
      };
      //this.map.setZoom(20);
      this.map.setCenter(pos);
    }
  }

  infoWindow(device, marker) {

    var contenidoInfo = '<div style="display:flex;">' +
      '<div style="flex:1;">' +
      '<img style="width: 100%;height: 100%;object-fit: cover;" src="' + GLOBAL.url + device.fotoPerfil + '" onerror="this.onerror=null; this.src=\'' + GLOBAL.url + 'no-photo-available.png\'" />' +
      '</div>' +
      '<div style="flex:1;margin-left: 10px;">' +
      '<label style="margin-left: 0px; font-size: 15px;font-weight: bold;flex:1;margin-bottom: 0px;">' +
      device.nombre +
      '</label>' +
      '<p style="margin-top: 10px;font-size: 12px;color: #E35100;">' +
      '<b>' + device.tipo_local + '</b>' +
      '</p>' +
      '<p style="font-size: 12px;color: #E35100;">' +
      '<b>' + device.tipo_comidas + '</b>' +
      '</p>' +
      '<p>' +
      '<b>' + device.direccion + '</b>' +
      '</p>' +
      '<button style="color:white;padding: 4px;border-radius: 0px; background-color:#E35100" onclick="window.location.href = \'establecimiento/' + device.id + '\';">Ver Carta</button>' +
      '</div>'
    '</div>';
    var infowindow = new google.maps.InfoWindow();
    infowindow.setContent(contenidoInfo);
    infowindow.setOptions({ maxWidth: 450 });
    infowindow.open(this.map, marker);
  }

  clickCambiarCantidad(tipo: string) {
    if (tipo == "subir") {
      this.cantidadCarrito++;
    } else {
      if (this.cantidadCarrito != 1) {
        this.cantidadCarrito--;
      }

    }
  }

  checkNumero() {

    if (this.cantidadCarrito < 1) {
      this.cantidadCarrito = 1;
    }
  }

  seleccionarPrecio(precio) {
    this.precioSeleccionado = precio;
  }

  clickHahstag = (url, mapa = false) => {
    this.router.navigateByUrl(url);

    if (mapa) {
      this.addMetrica(9);
    }
  }

  navegar(direccion) {
    this.router.navigate([direccion]);
  }

  addCarrito() {

    let carrito = JSON.parse(localStorage.getItem("carrito"));
    if (carrito == null) {
      carrito = {};
    }

    let model = {
      cantidad: this.cantidadCarrito,
      productoId: this.idProducto,
      precioId: this.precioSeleccionado.id,
      nota: ""
    };



    if (carrito["fabricante-" + this.fabricante.id] == null) {
      carrito["fabricante-" + this.fabricante.id] = [];
      carrito["fabricante-" + this.fabricante.id].push(model);
    } else {
      carrito["fabricante-" + this.fabricante.id].push(model);
    }

    localStorage.setItem("carrito", JSON.stringify(carrito));

    this.mostrarMensajeModalCarrito();

  }

  mostrarMensajeModalCarrito() {
    this.entry.clear();
    const factory = this.resolver.resolveComponentFactory(ModalConfirmComponent);
    this.refModalMensaje = this.entry.createComponent(factory);
    this.refModalMensaje.instance.mensaje = this.producto.nombre;
    this.refModalMensaje.instance.titulo = "Añadido al carrito";
    this.refModalMensaje.instance.showBotonCancelar = false;
    this.refModalMensaje.instance.showNotas = true;
    this.refModalMensaje.instance.botones = [
      {
        texto: "Seguir comprando", accion: () => {
          this.addNotaProductoCarrito();
          this.seguirComprando();
        }
      },{
        texto: "Ir al carrito", accion: () => {
          this.addNotaProductoCarrito();
          this.irAlCarrito()
        }
      }
      //{ texto: textoBotonCancelar, accion: funcionCancelar }

      /*      { texto: textoBotonConfirmar, accion: () => console.log('Botón OK presionado') },
           { texto: textoBotonCancelar, accion: () => console.log('Botón Cancelar presionado') } */
    ];
    this.refModalMensaje.changeDetectorRef.detectChanges();
  }

  irAlCarrito() {
    this.router.navigate(['carrito']);
  }

  seguirComprando() {
    this.navegar('fabricante/' + this.fabricante.slug);
  }

  addNotaProductoCarrito() {
    const nota = this.refModalMensaje.instance.nota;
    if (nota != "") {
      let carrito = JSON.parse(localStorage.getItem("carrito"));
      carrito["fabricante-" + this.fabricante.id][carrito["fabricante-" + this.fabricante.id].length - 1].nota = nota;
      localStorage.setItem("carrito", JSON.stringify(carrito));
    }
  }

}
